// extracted by mini-css-extract-plugin
export default {"titleWithGradient":"TitleWithGradient_titleWithGradient__K9dc4"};